import { deleteDoc, doc, getFirestore } from "firebase/firestore";
import { useCallback, useState } from "react";
import { toast } from "react-toastify";
import type {
  ModalDeleteAdminProps,
  UseModalDeleteAdminReturn,
} from "./types";

export const useModalDeleteAdmin = ({
  selectedAdmin,
  setModalDelete,
  setUsersAdminData,
}: ModalDeleteAdminProps): UseModalDeleteAdminReturn | null => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleClose = useCallback(() => {
    setModalDelete(false);
  }, [setModalDelete]);

  const deleteAdmin = useCallback(async () => {
    if (!selectedAdmin || isDeleting) {
      return;
    }

    setIsDeleting(true);

    try {
      const db = getFirestore();
      const adminRef = doc(db, "admin_users", selectedAdmin.uid);

      await deleteDoc(adminRef);

      setUsersAdminData((prevAdmins) =>
        prevAdmins
          ? prevAdmins.filter((admin) => admin.uid !== selectedAdmin.uid)
          : prevAdmins
      );

      handleClose();
      toast.success("Administrador eliminado con exito");
    } catch (error) {
      console.error("Error al eliminar administrador:", error);
      toast.error("No se pudo eliminar el administrador");
    } finally {
      setIsDeleting(false);
    }
  }, [handleClose, isDeleting, selectedAdmin, setUsersAdminData]);

  if (!selectedAdmin) {
    return null;
  }

  return {
    deleteAdmin,
    handleClose,
    isDeleting,
    selectedAdmin,
  };
};
